import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import Image from '../components/Image';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Al fin podemos arrancar a hacer nuestro portfolio! 🎉🎊🎉🎊 Empecemos con lo
primero, la idea es traernos desde Github nuestros proyectos, así que para
lograr eso necesitamos consumir la API de GraphQL de Github. Pensemos esto
`}<em parentName="p">{`Gatsby style`}</em>{` como veníamos pensando con los plugins, necesitamos entonces:`}</p>
    <ul>
      <li parentName="ul">{`Una `}<strong parentName="li">{`fuente de datos`}</strong>{` (`}<em parentName="li">{`source`}</em>{`) que van a ser `}<strong parentName="li">{`nuestros proyectos`}</strong>{`, la
cual vamos a exponer por medio de un plugin de tipo `}<em parentName="li">{`source`}</em>{`.`}</li>
      <li parentName="ul">{`El mismo plugin se encarga de traernos en un JSON todo preparadito con el
texto incluyendo la data que nosotros elijamos 😜, así que no sería necesario
`}<strong parentName="li">{`transformar`}</strong>{` (`}<em parentName="li">{`transform`}</em>{`) esa data.`}</li>
      <li parentName="ul">{`Una vez que esté todo hecho y configurado, vamos a poder `}<strong parentName="li">{`usar`}</strong>{` esa data en
el frontend consultándola por medio de `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`GraphQL`}</code>{`.`}</li>
    </ul>
    <p>{`Vamos a buscar un plugin de tipo source para lo que necesitamos, entremos en la
sección de `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/plugins/"
      }}>{`plugins de Gatsby`}</a>{` y busquemos en
la barra de la izquierda "`}<em parentName="p">{`github`}</em>{`". Vamos a ver que nos sugiere algunas
opciones pero a nosotros nos interesa
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/packages/gatsby-source-github-api/"
      }}><strong parentName="a">{`gatsby-source-github-api`}</strong></a>{`,
así que hagamos click en ese y empecemos a leer la docu (les recomiendo
`}<strong parentName="p">{`SIEMPRE`}</strong>{` leer la documentación, de todo lo que usen jaja 😉). Si leemos la
descripción, vemos que es exactamente lo que necesitamos, así que vamos a
instalarlo:`}</p>
    <p>{`Vayamos a la consola y en el root de nuestro proyecto (`}<em parentName="p">{`si tenemos el servidor
local de Gatsby, lo frenamos con `}<code parentName="em" {...{
          "className": "language-text"
        }}>{`Ctrl + C`}</code></em>{`) y tipeemos lo siguiente:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i gatsby-source-github-api`}</code></pre></div>
    <p>{`Mientras se instala, sigamos leyendo la docu.`}</p>
    <p>{`Veremos que lo primero que dice es que vamos a necesitar un `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`token`}</code>{` para poder
consumir la API de GraphQL de Github, así que vamos a `}<a parentName="p" {...{
        "href": "http://www.github.com"
      }}>{`www.github.com`}</a>{` y, si
estamos "logueados", hacemos click en nuestro avatar en la esquina superior
derecha y en el menú seleccionamos la opción `}<strong parentName="p">{`Settings`}</strong>{`. Luego en las opciones
vamos a la que debería ser la última, `}<strong parentName="p">{`Developer settings`}</strong>{`, luego `}<strong parentName="p">{`Personal
access tokens`}</strong>{` donde vamos a ver algo así (si es que tenemos alguna generada)`}</p>
    <Image imgName="tokens.png" alt="Personal access tokens" mdxType="Image" />
    <p>{`Como tenemos que generar una nueva para nuestra interacción con el plugin,
tenemos que hacer click en el botón `}<strong parentName="p">{`Generate new token`}</strong>{`. Acá Github nos va a
recibir con una linda tabla llena de checkboxes pero no se preocupen, es por su
bien 😌. En el input vamos a poner algo descriptivo sobre para qué es este
token, por ejemplo, `}<em parentName="p">{`Portfolio personal`}</em>{`.`}</p>
    <p>{`Luego debemos elegir a qué cosas podemos acceder con este token, y ya que
solamente nos interesa leer datos, seleccionemos algunos que sean `}<strong parentName="p">{`read`}</strong>{`. En
nuestro caso con seleccionar las opciones `}<strong parentName="p">{`public_repo`}</strong>{` y `}<strong parentName="p">{`read:user`}</strong>{` nos
alcanza. Una vez que seleccionemos esto, vamos abajo de todo a `}<strong parentName="p">{`Generate
token`}</strong>{`.`}</p>
    <Image imgName="token_gen.png" alt="Token generado" mdxType="Image" />
    <p><em parentName="p">{`No se gasten en usar ese token que ya lo borré antes de escribir esto por las
dudas, paranoico yo?`}</em>{` 🤣`}</p>
    <p>{`Copien y guarden en algún archivo de texto ese token por las dudas, lo digo por
experiencia propia jajaja.`}</p>
    <p>{`Ahora sigamos con la configuración del plugin, nos dice que una vez que tengamos
el `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`token`}</code>{` y hayamos instalado el plugin, que vayamos a nuestro archivo
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{` para agregarlo y configurarlo con el siguiente código:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// En gatsby-config.js`}</span>{`
plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-source-github-api`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// token: el que generamos recién, requerido por la API de GitHub`}</span>{`
      token`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`nuestro-token-va-acá`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`

      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// GraphQLquery: con esta query, traemos a nuestro backend lo que`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// queremos tener disponible para mostrar en nuestro frontend`}</span>{`
      graphQLQuery`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
        query {
          /* En el próximo paso vamos a ver cómo armar la query */
        }
      `}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`

      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// variables: por si necesitamos utilizar variables en nuestra query,`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// no vamos a usarlo así que podemos borrarlo`}</span>{`
      variables`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        lasVariables`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'que necesitemos'`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span></code></pre></div>
    <p>{`Entonces hagamos eso, agreguemos a nuestro proyecto el plugin, nos quedaría así:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// En gatsby-config.js`}</span>{`
plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`/* [...] */`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-source-github-api`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      token`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`079b55830a613c38aff7f4608ef2448d83db9758`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      graphQLQuery`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
        query {
          /* En el próximo paso vamos a ver cómo armar la query */
        }
      `}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`/* [...] */`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span></code></pre></div>
    <p><em parentName="p">{`Sí, el token lo escribí a mano porque como dije antes, lo borré y no lo guardé`}</em>{`
🤦‍♂️`}</p>
    <p>{`Listo, todo muy lindo, pero ahora, la query?!?!? Cómo la hacemos?`}</p>
    <p>{`Vayamos a la siguiente sección para aprender algo copado, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`GraphQL`}</code>{` 🤩`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      